import * as React from 'react'

import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
//import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
//import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
//import amber from '@material-ui/core/colors/amber';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';

//import { useTheme } from '@material-ui/core/styles';
//import useMediaQuery from '@material-ui/core/useMediaQuery';

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import { Link } from '@material-ui/core';

import './App.css';

//import office from './img/IMG_5232.jpg'
import office1 from './img/IMG_5336.jpg'
import office2 from './img/IMG_5350.jpg'
import office3 from './img/IMG_5348.jpg'
//import tiles from './img/DSC_0751.jpeg'

import img1 from './img/img1.jpg'
import img2 from './img/img2.jpg'
import img3 from './img/img3.jpg'
import img4 from './img/img4.jpg'
import img5 from './img/img5.jpg'
import img6 from './img/img6.jpg'
import img7 from './img/img7.jpg'
import img8 from './img/img8.jpg'
import img9 from './img/img9.jpg'
//import img10 from './img/img10.jpg'
import img11 from './img/img11.jpg'

import {Link as ScrollLink} from 'react-scroll'

import {useForm} from 'react-hook-form'
import {useMutation} from 'react-query'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import useStyles from './style.js'
import {useClient, Copyright} from './common.js'

function App() {

    const classes = useStyles();

    const client = useClient()

    const mutation = useMutation(
        updates =>
            client(`/api/hi`, {
                method: 'POST',
                data: updates,
            })
    )

    const [submitted, setSubmitted] = React.useState(false)

    const [serverError, setServerError] = React.useState(false)

    const onSuccess = (data, variables, context) => setSubmitted(true)

    const onError = (data, variables, context) => setServerError(data)

    const onSubmit = (data) => {setServerError(false); mutation.mutate({data}, {onSuccess, onError})}

    const {register, handleSubmit, formState: { errors }} = useForm({ mode: 'blur', defaultValues: {}})

    return (
        <div className={classes.root}>
            <CssBaseline />
            <React.Fragment>
                <Container maxWidth="md" id="top">
                    <Grid item>

                        <Typography variant="h4" component="h1" className={classes.tmp}>
                        A Home For Work
                        </Typography>
                          <List>
                            <ListItem>
                                <ListItemText>
                                                <Typography
                                                    component={ScrollLink}
                                                    to="concept"
                                                    spy={true}
                                                    smooth={true}
                                                    offset={-70}
                                                    duration={1000}
                                                    className={classes.mobilemenu}
                                                >
                                                   Concept 
                                </Typography>
                                </ListItemText>  
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                                <Typography
                                                    component={ScrollLink}
                                                    to="details"
                                                    spy={true}
                                                    smooth={true}
                                                    offset={-70}
                                                    duration={1000}
                                                    className={classes.mobilemenu}
                                                >
                                                    Design 
                                </Typography>
                                </ListItemText>  
                            </ListItem>
                            <ListItem>
                                <ListItemText>

                                                <Typography 
                                                    component={ScrollLink}
                                                    to="tech"
                                                    spy={true}
                                                    smooth={true}
                                                    offset={-70}
                                                    duration={1000}
                                                    className={classes.mobilemenu}
                                                >
                                                    Spec 
                                                </Typography>



                                </ListItemText>  
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                                <Typography
                                                    component={ScrollLink}
                                                    to="questions"
                                                    spy={true}
                                                    smooth={true}
                                                    offset={-70}
                                                    duration={1000}
                                                    className={classes.mobilemenu}
                                                >
                                                    Questions
                                                </Typography>



                                </ListItemText>  
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                                <Typography
                                                    component={ScrollLink}
                                                    to="contactform"
                                                    spy={true}
                                                    smooth={true}
                                                    offset={-70}
                                                    duration={1000}
                                                    className={classes.mobilemenu}
                                                >
                                                    Contact
                                                </Typography>


                                </ListItemText>  
                            </ListItem>
                          </List>
                    </Grid>

                </Container>
            </React.Fragment>


            <Container component="section" className={classes.title} maxWidth="md">
                <Grid container component="div" className={classes.header}>

                    <Grid item xs={12} sm={12} md={6} >
                        <img src={`${office1}`} alt="stuff" className={classes.imagething}/>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} component={Paper} elevation={0} square className={classes.boxleft}>

                        <Typography variant="h5" component="h2" gutterBottom className={classes.bold} id="concept">
                            {'Concept'}
                            {/*
                            <span>{`theme.breakpoints.up('xl') desktop: ${desktop}`}</span>
                            */}
                        </Typography>

                        <Typography variant="h6" component="" gutterBottom>
                            When the occasional working from home day becomes a bit more permanent, being
                            cramped up in the spare room just doesn’t cut it.
                            That’s why we’ve designed a office 
                            for your garden, which is not only highly functional, but beautiful as well.
                            Designed first and foremost as an office,
                            rather than just a nondescript building in your
                            garden, it comes with everything you need to get
                            started.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>


            <Container component="section" className={classes.main} maxWidth="md">
                <Grid container className={classes.header}>
                    <Grid item xs={12} sm={12} md={12}>

                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img2}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img1}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img3}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img4}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${office2}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${office3}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.title} maxWidth="md">
                <Grid container component="div" className={classes.header}>
                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={0} square className={classes.box} id="details">
                        <Typography variant="h5" component="h2" gutterBottom className={classes.bold}>
                            {'Design'}
                        </Typography>

                        <Typography variant="h6" component="" gutterBottom>
                            Too many garden office companies leave you with a
                            set of keys, but no desk, carpet, or quote integral
                            features, such as foundations, as extra. Our approach
                            is different. We want to build a place for you to work
                            that has everything you need to get started from the
                            moment we hand you your keys.
                        </Typography>
                        <Typography variant="h6" component="" gutterBottom>
                            Besides designing a useful space, we want to design an office that looks
                            beautiful. We’ve become used to some pretty nice
                            working environments while at the office, and we wanted
                            to provide a similar experience at home. Bog standard
                            garden offices are ok, but they still look like a spare
                            room with their utility boxes stuck on walls, protruding
                            radiators, and boring plasterboard walls.
                        </Typography>
                        <Typography variant="h6" component="" gutterBottom>
                            Our office is different. Externally the office is covered by innovative tiles
                            manufactured from up-cycled PVC.
                             The tiles cover
                            most of the exterior except for a large format high
                            quality aluminium
                            window on one aspect of the
                            office which not only lets in lot’s of natural
                            light, but allows you to enjoy your garden. It is a
                            garden office after all. 
                            In front of the window an integrated desk extends
                            across the full width of the office, affording lots
                            of space to spread out, and an integrated solar blind
                            helpss control glare and heat. 
                            Heating and cooling
                            the office is managed by environmentally friendly
                            air conditioning and underfloor heating. 
                            The walls of the office are finished in a premium birch plywood which
                            diffuse the light entering from the window.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md">
                <Grid container className={classes.header}>
                    <Grid item xs={12} sm={12} md={12} >
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img7}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img8}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img9}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>

                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    {/*        <img src={`${img10}`} alt="stuff" style={{'max-width': '100%'}}/>*/}
                                    <img src={`${img5}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img11}`} alt="stuff" className={classes.image} />
                                </Paper>
                            </Grid>
                            <Grid item xs>
                                <Paper className={classes.paper} elevation={0}>
                                    <img src={`${img6}`} alt="stuff" className={classes.image}/>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md">
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={0} square className={classes.box}>
                        <Typography variant="h6" component="" gutterBottom>

                            A convenient peg wall provides a place to hang your
                            belongings or install shelving. There are several
                            options for the floor including natural carpet, rubber
                            flooring, or woven vinyl carpet. It was important in
                            the design for all cables and wall boxes to be hidden,
                            so they have been located in a convenient utility area. 
 
                        </Typography>

                        <Typography variant="h6" component="" gutterBottom>
                            Finally, once everything has been built we’ll also
                            help you get your IT set up so you can truly get to
                            work.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md">
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={0} square className={classes.box}>
                        <Typography variant="h5" component="h2" gutterBottom className={classes.bold}>
                            {"What we're looking for"}
                        </Typography>

                        <Typography variant="h6" component="" gutterBottom>
                            We’re looking for our first customer to work with
                            us in creating office number one. It's that simple. We'll build 
                            you a fantastic garden office, at a reduced rate and 
                            all we need in return is
                            to be able to take some photos, and a testimonial.
                            If this sounds interesting then &#8239;

                            <Link
                                component={ScrollLink}
                                to="contactform"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={1000}
                                className={classes.link}
                            >get in touch</Link>.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md" id="tech">

                <Grid container>
                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={0} square className={classes.box}>
                        <Typography variant="h5" component="h2" gutterBottom className={classes.bold}>
                            {'Spec'}
                        </Typography>

                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Interior'}
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            {'Integrated desk, set at the right height for you'}
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            {'High finished birch plywood'}
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            {'Convienient peg wall for hanging and shelving'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Rolling blind to minimise glare and control temperature'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Floor'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Hardwearing natural carpet, rubber flooring, or woven vinyl carpet'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Foundation'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Helical screw pile. Easy to install, and not a hint of concrete'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Heating'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Underfloor heating'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Cooling'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Enviromentally friendly air conditioning'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Ventilation'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Natural ventilation, adjustable airflow'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Glass'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Energy efficient toughened double glazing with UV protection'}
                        </Typography>

                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Exterior'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Cladding material from up-cycled pvc'}
                        </Typography>

                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Electrical'}
                        </Typography>
                        <Typography variant="body1" gutterbottom >
                            {'4 x led downlights'}
                        </Typography>
                        <Typography variant="body1" gutterbottom >
                            {'3 x double power outlet'}
                        </Typography>
                        <Typography variant="body1" gutterbottom paragraph>
                            {'1 x dimmer lightswitch'}
                        </Typography>
                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Weight'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'Approx 2,000 kg'}
                        </Typography>

                        <Typography variant="body1" className={classes.bold} gutterBottom>
                            {'Internal dimensions'}
                        </Typography>
                        <Typography variant="body1" gutterBottom paragraph>
                            {'W 2 x L 3 x H 2.1 m '}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md" id="questions">

                <Grid container>

                    <Grid item xs={12} sm={12} md={12} component={Paper} elevation={0} square className={classes.box}>
                        <Typography variant="h5" component="h2" gutterBottom className={classes.bold}>
                            {'Questions'}
                        </Typography>

                        <Typography variant="h6" className={classes.bold}>
                            How much does the garden office cost?
                        </Typography>
                        <Typography variant="h6" gutterBottom style={{'margin-bottom': '1.5em'}}>
                            Based on current material costs, we are quoting
                            £12,000 for complete installation. This price
                            includes all electrical work within the office, but
                            does not include bringing electricity from your
                            residence to the office.
                        </Typography>

                        <Typography variant="h6" className={classes.bold}>
                            How long does it take to complete?
                        </Typography>
                        <Typography variant="h6" gutterBottom style={{'margin-bottom': '1.5em'}}>
                            We'd expect to be finished within 10 working days.
                        </Typography>

                        <Typography variant="h6" className={classes.bold}>
                            What is the lead time?
                        </Typography>
                        <Typography variant="h6" gutterBottom style={{'margin-bottom': '1.5em'}}>
                            The current lead time is about 5 weeks.
                        </Typography>


                        <Typography variant="h6" className={classes.bold}>
                            What's not included in the price?
                        </Typography>
                        <Typography variant="h6" gutterBottom style={{'margin-bottom': '1.5em'}}>
                            Electricity supply from your
                            residence to the office is not included in the price.
                            The simple reason is we don't know how far the
                            office will be from your house. However, an on-site
                            survey would be performed prior to purchase
                            agreement and a quote provided for electrical
                            connection. If you would like to proceed, we will undertake
                            all works necessary to bring electricity to the office.
                        </Typography>

                    </Grid>
                </Grid>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md" id="contactform">
                <Typography variant="h5" component="h2" gutterBottom className={classes.bold}>
                    {'Contact'}
                </Typography>

                {!submitted &&
                <>
                <Typography variant="h6" gutterBottom>
                    So if you'd like to escape the kitchen
                    table, send us your mobile number and we'll get straight
                    back to you.
                </Typography>
                <Typography variant="h6" gutterBottom>
                    (it might take up to 5 minutes).
                </Typography>

                {serverError && <Typography variant="body1" color="error">{`${serverError.message}`}</Typography>}

                <Grid container className={classes.stuff}>
                    <Grid item xs={12} sm={12} md={6} elevation={0} square>
                        
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">

                            <FormControl className={classes.formcontrol} error={false} fullWidth={true}>
                                <Typography variant="body1" className={classes.bold} gutterBottom>
                                    {'Name'}
                                </Typography>

                                <OutlinedInput
                                    fullWidth={true}
                                    multiline={false}

                                    {...register('name', {required: "We need your name"})}
                                />
                                {errors.name && <Typography variant="body1">{errors.name.message}</Typography>}
                            </FormControl>

                            <FormControl className={classes.formcontrol} error={false} fullWidth={true}>
                                <Typography variant="body1" className={classes.bold} gutterBottom>
                                    {'Phone number'}
                                </Typography>

                                <OutlinedInput
                                    fullWidth={true}
                                    multiline={false}
                                    {...register('phone', {
                                            required: "We need your phone number",
                                            pattern: {
                                                value: /[0-9]+/,
                                                message: "Just numbers please"
                                            }

                                        }
                                    )}
                                />
                                {errors.phone && <Typography variant="body1">{errors.phone.message}</Typography>}
                            </FormControl>

                            {!mutation.isLoading && <Button variant="outlined" type="submit" className={classes.submitbutton}>Say hi</Button>}
                            {mutation.isLoading && <Button variant="outlined" className={classes.submitbutton}>Sending...</Button>}
                        </form>
                    </Grid>
                </Grid>
                </>
                }
                        
                {submitted &&
                    <Grid container component="div">
                    <Grid item xs={12} sm={12} md={6} elevation={0} square>
                        <Typography variant="body1" gutterBottom>
                        Thanks, we'll be in touch soon.
                        </Typography>
                    </Grid>
                </Grid>
                }

            </Container>

            <Container component="section" maxWidth="md" className={classes.top}>
                <Typography
                    variant="h6"
                    component={ScrollLink}
                    to="top"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={1000}
                    className={classes.top}
                >
                    <ArrowUpwardIcon/>
                </Typography>
            </Container>

            <Container component="section" className={classes.main} maxWidth="md">
                <footer className={classes.footer}>
                    <Copyright />
                </footer>
            </Container>
        </div>
    );
}

export default App;
